import map from 'lodash/map';
import React, { FC, MouseEvent } from 'react';

import { ImageSwipe } from 'components/pages/ProductDetails/types/Imageswipe';
import { Product } from 'models/product';

export const Thumbnails: FC<{
  displayProductImage: (e: MouseEvent<HTMLElement>) => void;
  gridArea: string;
  imageSwipe: ImageSwipe;
  imagesAlt: string;
  product: Product;
}> = ({ displayProductImage, gridArea, imagesAlt, imageSwipe, product: { images, model } }) => {
  return (
    <div className="thumbnails desktop-flex">
      {map(images, (curr, index) => (
        <span
          key={`thumb_img_${index}`}
          className={`thumbnail-wrapper${index === imageSwipe.currentImageIndex ? ' active' : ''}`}
          data-image={curr.medium}
          data-image-index={index}
          data-zoom-id="zoomer"
          id={`thumb:${index}`}
          onClick={displayProductImage}
        >
          <img alt={imagesAlt} className="thumbnail" src={curr.thumb} title={model} />
        </span>
      ))}
      <style jsx>{`
        .thumbnails {
          grid-area: ${gridArea};
          width: 100%;
          flex-direction: column;
          margin-top: 20px;
        }

        .thumbnail-wrapper {
          cursor: pointer;
        }

        .thumbnail {
          width: 70px;
          margin-bottom: 8px;
        }
      `}</style>
    </div>
  );
};
